module.exports = __webpack_public_path__ + "img/forgot_password.2b290860.png";